export default __webpack_public_path__ + "static/media/connecting_web-xs@2x.0480622c.jpg";